<template>
    <v-dialog persistent v-model="get_dialogSecoundMain.dialog" width="950px" justify-center>
        <v-toolbar dense dark color="blue darken-2">
            <v-toolbar-title>
                <h3>Grafica de encuesta :<span v-if="model"> {{model.nombre}}</span> </h3>
            </v-toolbar-title>
        <v-spacer></v-spacer>
            <v-btn icon dark @click="HIDDE_DIALOG_SECOUND_MAIN()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-card width="auto" tile>
            <v-card-text>
                <v-row dense v-if="showGraf">
                    <v-col cols="6" v-for="(obj, index) in respuestas " :key="index">
                        <fusioncharts
                            type="column2d"
                            :width="width"
                            :height="height"
                            dataFormat="json"
                            :dataSource="obj">
                                FusionCharts will render here...
                        </fusioncharts>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-end>
                    <v-btn class="red darken-1 mr-3" dark @click="HIDDE_DIALOG_SECOUND_MAIN()">Cerrar</v-btn>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  props: ['model'],
  data: () => ({
    width: '100%',
    height: '300',
    type: 'column2d',
    dataFormat: 'json',
    showGraf: false,
    respuestas: []
  }),
  components: {},
  mounted () {
    this.getUrl('survey.showbyid')
  },
  methods: {
    ...mapActions(['getUrlServices', 'postUrlServicesListAction']),
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        // router.data = { id: this.model.id }
        this.postUrlServicesListAction({ url: router, data: { id: this.model.id } })
      } else {
        this.getUrlServices()
      }
    },
    getUrlEncuesta (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postUrlServicesListActionSecound({ url: router })
      } else {
        this.getUrlServices()
      }
    },
    pieDataSource (obj) {
      return {
        chart: {
          caption: obj.pregunta,
          xaxisname: 'Respuestas',
          yaxisname: 'Total de resultado',
          theme: 'fusion'
        },
        data: obj.respuestas
      }
    },
    ...mapMutations(['HIDDE_DIALOG_SECOUND_MAIN', 'SET_DATA_MAIN', 'CLEAR_DATA_MAIN'])
  },
  computed: {
    ...mapGetters(['get_dialogSecoundMain', 'get_urls', 'get_objects'])
  },
  watch: {
    get_urls () {
      this.getUrl('survey.showbyid')
    },
    get_objects (val) {
      this.respuestas = val.map(item => {
        return {
          chart: {
            caption: item.pregunta,
            xaxisname: 'Respuestas',
            yaxisname: 'Total de resultado',
            theme: 'fusion'
          },
          data: item.respuestas
        }
      })

      this.showGraf = true
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_MAIN()
  }
}
</script>

<style>
</style>
